import List from "@/components/list";

const Table = args => {
  const AccountTableConfig = [
    {
      label: "回复内容",
      prop: "smsReplyContent"
    },
    {
      label: "回复时间",
      prop: "smsReplyDate"
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export default Table;
